const storeName = 'CONFIG';

export default {
    SET_CONFIGS: `${storeName}.SET_CONFIGS`,
};
